import { useMutation } from '@tanstack/react-query';
import useApi from './useApi';

type CreateCasePayload = {
  pat_guid: string;
  client_case_id: string;
  caseUrgency: string;
  speccat: string;
  specarea?: string;
  cohort_number?: number;
  first_appt?: boolean;
};

const useCreateCaseMutation = () => {
  const { Api } = useApi();

  return useMutation({
    mutationFn: async (payload: CreateCasePayload): Promise<number> => {
      try {
        const response = await Api.cases.putCreateCase(payload);

        return response?.data?.case_id;
      } catch (e: any) {
        throw new Error(e?.response?.data?.message ?? 'Failed to create new Case');
      }
    }
  });
};

export default useCreateCaseMutation;
